import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import { getAuthHeaders } from "../utils/auth";
import "../styles/BlogsManagement.css"; // Reusing grid styles for consistency

const NewsletterManagement = () => {
    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchNewsletters();
    }, []);

    const fetchNewsletters = async () => {
        try {
            const headers = getAuthHeaders(false);
            const res = await fetch(`${BASE_URL}/newsletter`, { headers });

            if (res.ok) {
                const data = await res.json();
                if (data.success) {
                    setEmails(data.data || []);
                }
            } else {
                setError("Failed to fetch newsletter subscribers");
            }
        } catch (error) {
            setError("Error loading data");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to remove this email?")) return;

        try {
            const headers = getAuthHeaders(false);
            const res = await fetch(`${BASE_URL}/newsletter/${id}`, {
                method: "DELETE",
                headers
            });

            if (res.ok) {
                setEmails(emails.filter(item => item._id !== id));
            } else {
                alert("Failed to delete");
            }
        } catch (error) {
            alert("Error deleting email");
        }
    };

    if (loading) return <div className="admin-loading">Loading...</div>;

    return (
        <div className="blogs-management">
            <div className="blogs-header">
                <h3>Newsletter Subscribers ({emails.length})</h3>
                <button className="refresh-btn" onClick={fetchNewsletters}>
                    <i className="ri-refresh-line"></i> Refresh
                </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="bookings-grid" style={{ gridTemplateColumns: "1fr" }}> {/* Using list view */}
                {emails.length === 0 ? (
                    <div className="empty-state">No subscribers yet.</div>
                ) : (
                    <table className="tours-table" style={{ width: "100%", textAlign: "left" }}>
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Subscribed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails.map((item) => (
                                <tr key={item._id}>
                                    <td>{item.email}</td>
                                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <button className="delete-btn" onClick={() => handleDelete(item._id)}>
                                            <i className="ri-delete-bin-line"></i> Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default NewsletterManagement;
